module.exports = __webpack_public_path__ + "media/images/hard-disk-drive-hdd-9782f9d6299e5707662849de99a64d37.svg";